<app-admin-header></app-admin-header>

<div class="issue-drug-container">
  <app-admin-sidebar></app-admin-sidebar>

  <div class="page-header">
    <h2>💊 Issue Drug to Patient</h2>
    <button class="open-modal-btn" (click)="showIssueModal = true">➕ New Issue</button>
  </div>

  <div class="feedback" *ngIf="successMessage || errorMessage">
    <div class="success" *ngIf="successMessage">{{ successMessage }}</div>
    <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>
  </div>

  <!-- 🔹 Drug Issue Modal -->
  <div class="modal-backdrop" *ngIf="showIssueModal">
    <div class="modal">
      <h3>💊 Issue Drug</h3>

      <form (ngSubmit)="submitIssue()" class="modal-form">
        <!-- Store -->
        <label>Store:</label>
        <select [(ngModel)]="issue.store_id" name="store_id" (change)="checkStockBalance()" required>
          <option [ngValue]="null">-- Select Store --</option>
          <option *ngFor="let store of stores" [ngValue]="store.id">{{ store.name }}</option>
        </select>

        <!-- Drug search -->
        <label>Drug:</label>
        <input
          type="text"
          [(ngModel)]="drugSearch"
          (input)="filterDrugs()"
          placeholder="Search drugs..."
          name="drugSearch"
        />
        <select [(ngModel)]="issue.stock_item_id" name="stock_item_id" (change)="checkStockBalance()" required>
          <option [ngValue]="null">-- Select Drug --</option>
          <option *ngFor="let item of filteredStockItems" [ngValue]="item.id">{{ item.name }}</option>
        </select>

        <!-- Quantity -->
        <label>Quantity:</label>
        <input type="number" [(ngModel)]="issue.quantity" name="quantity" required min="1" />

        <!-- Patient type -->
        <label>Patient Type:</label>
        <select [(ngModel)]="issue.patient_type" name="patient_type">
          <option value="in-patient">In-Patient</option>
          <option value="out-patient">Out-Patient</option>
        </select>

        <!-- Search & Select Patient -->
        <label>Search Patient:</label>
        <input type="text" [(ngModel)]="searchPatient" (input)="filterPatients()" name="search" placeholder="Search..." />
        <label>Select Patient:</label>
        <select [(ngModel)]="issue.patient_id" name="patient_id" required>
          <option [ngValue]="null">-- Select Patient --</option>
          <option *ngFor="let patient of filteredPatients" [ngValue]="patient.id">
            {{ patient.surname }} {{ patient.other_names }} ({{ patient.type }})
          </option>
        </select>

        <!-- Note -->
        <label>Note (optional):</label>
        <input type="text" [(ngModel)]="issue.note" name="note" />

        <!-- Actions -->
        <div class="modal-actions">
          <button type="submit" [disabled]="isSubmitting">
            {{ isSubmitting ? 'Processing...' : 'Issue Drug' }}
          </button>
          <button type="button" class="cancel" (click)="showIssueModal = false">Cancel</button>
        </div>
      </form>
    </div>
  </div>

  <hr />

  <!-- 🔍 Date filter -->
  <div class="date-filters">
    <label>From:</label>
    <input type="date" [(ngModel)]="filterStartDate" (change)="applyDateFilter()" />
    <label>To:</label>
    <input type="date" [(ngModel)]="filterEndDate" (change)="applyDateFilter()" />
  </div>

  <h3>📝 Recent Drug Issues</h3>
  <div *ngIf="loadingIssues">⏳ Loading recent issues...</div>

  <table class="stock-table" *ngIf="!loadingIssues && recentIssues.length">
  <thead>
    <tr>
      <th>Drug</th>
      <th>Patient</th>
      <th>Type</th>
      <th>Store</th>
      <th>Quantity</th>
      <th>Date</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let issue of paginatedIssues()">
      <td>
        <span class="label">Drug:</span>
        <span class="value">{{ issue.stock_item_name }}</span>
      </td>
      <td>
        <span class="label">Patient:</span>
        <span class="value">{{ issue.patient_name }}</span>
      </td>
      <td>
        <span class="label">Type:</span>
        <span class="value">{{ issue.patient_type }}</span>
      </td>
      <td>
        <span class="label">Store:</span>
        <span class="value">{{ issue.store_name }}</span>
      </td>
      <td>
        <span class="label">Quantity:</span>
        <span class="value">{{ issue.quantity }}</span>
      </td>
      <td>
        <span class="label">Date:</span>
        <span class="value">{{ issue.created_at | date: 'short' }}</span>
      </td>
    </tr>
  </tbody>
</table>


  <div class="pagination">
    <button (click)="currentPage = currentPage - 1" [disabled]="currentPage === 1">⬅️</button>
    Page {{ currentPage }}
    <button (click)="currentPage = currentPage + 1" [disabled]="currentPage * pageSize >= filteredIssues.length">➡️</button>
  </div>
</div>
